import {IPlannerPropertyRoomExposureSide} from "../../types/planner_property/IPlannerPropertyRoomExposureSide";
import {IPlannerRoomNames} from "../../types/planner_property/IPlannerRoomNames";
import {countRoomsByType} from "./room_exposure/count_rooms_by_type";
import {getOnlyRoomsWithExposure, RoomWithRequiredExposure} from "./room_exposure/get_only_rooms_with_exposure";
import {groupRoomsByExposure} from "./room_exposure/group_rooms_by_exposure";
import {getPlannerPropertyWorldSideName} from "./get_planner_property_world_side_name";
import {getPlannerPropertyRoomNameDeclensionWhere} from "./getPlannerPropertyRoomName";
import {normalizePlannerPropertyRoomTypes} from "./normalize_planner_property_room_types";

export type RoomsNormalized = ReturnType<typeof normalizePlannerPropertyRoomTypes>;

export const getPlannerMultiWorldSideRoomsDescription = (roomsNormalized: RoomsNormalized) => {
    const roomsWithExposure = getOnlyRoomsWithExposure(roomsNormalized);
    const roomsGroupedByExposure = groupRoomsByExposure(roomsWithExposure);

    if (!roomsWithExposure) {
        return "";
    }

    const entries = Object.entries(roomsGroupedByExposure);
    const prevRoomsCountByType: Record<string, number>[] = [];

    const roomsExposureDescription = entries
        .map(([_exposureKey, rooms], index) => {
            const exposure = rooms[0].exposure; // all rooms have the same exposure
            const isLastEntry = index === entries.length - 1;
            const joinSeparator = index > 0 ? (isLastEntry ? ", a okna z " : ", z ") : "z ";
            const roomsInfo = generateRoomsInfo(rooms, prevRoomsCountByType);
            prevRoomsCountByType.push(roomsInfo.roomsCountByType);

            return `${joinSeparator}${roomsInfo.description}${index === 0 ? " wychodzą na " : " na "}${generateExposureDescription(exposure)}`;
        })
        .join("");

    return roomsExposureDescription ? `Okna ${roomsExposureDescription}.` : "";
};

const generateExposureDescription = (exposure: IPlannerPropertyRoomExposureSide[]) => {
    const joinSeparator = exposure.length > 2 ? ", " : " oraz ";
    return exposure.map((exposure) => getPlannerPropertyWorldSideName(exposure)).join(joinSeparator);
};

const generateRoomsInfo = (rooms: RoomWithRequiredExposure[], pastRoomsCountByType: Record<string, number>[]) => {
    const roomTypeCountByGroupNumerals = [
        "",
        "pierwszej ",
        "drugiej ",
        "trzeciej ",
        "czwartej ",
        "piątej ",
        "szóstej ",
        "siódmej ",
        "ósmej ",
        "dziewiątej ",
        "dziesiątej "
    ];
    const numeralsToText = ["", "", "dwóch ", "trzech ", "czterech ", "pięciu ", "sześciu ", "siedmiu ", "ośmiu ", "dziewięciu ", "dziesięciu "];
    const roomsCountByType = countRoomsByType(rooms);
    const entries = Object.entries(roomsCountByType);

    const description = entries
        .map(([roomType, count], index) => {
            const countToText = numeralsToText[count] || "";
            const roomTypeToText = getPlannerPropertyRoomNameDeclensionWhere(roomType as IPlannerRoomNames)(count);
            const isLastEntry = index === entries.length - 1;
            const joinSeparator = index > 0 ? (isLastEntry ? " oraz " : ", ") : "";
            const prevRoomsCountByType = pastRoomsCountByType.reduce(
                (acc, prevCountByRoomType) => (prevCountByRoomType[roomType] ? prevCountByRoomType[roomType] + acc : acc),
                0
            );
            const groupNumeralToText = prevRoomsCountByType === 0 || count > 1 ? countToText : `${roomTypeCountByGroupNumerals[prevRoomsCountByType + 1]}`;

            return `${joinSeparator}${groupNumeralToText}${roomTypeToText}`;
        })
        .join("");

    return {
        description,
        roomsCountByType
    };
};
import {IPlannerPropertyRoomExposureSide} from "../../types/planner_property/IPlannerPropertyRoomExposureSide";
import {IPlannerRoomNames} from "../../types/planner_property/IPlannerRoomNames";
import {countRoomsByType} from "./room_exposure/count_rooms_by_type";
import {getOnlyRoomsWithExposure, RoomWithRequiredExposure} from "./room_exposure/get_only_rooms_with_exposure";
import {groupRoomsByExposure} from "./room_exposure/group_rooms_by_exposure";
import {getPlannerPropertyWorldSideName} from "./get_planner_property_world_side_name";
import {getPlannerPropertyRoomNameDeclensionWhere} from "./getPlannerPropertyRoomName";
import {normalizePlannerPropertyRoomTypes} from "./normalize_planner_property_room_types";

export type RoomsNormalized = ReturnType<typeof normalizePlannerPropertyRoomTypes>;

export const getPlannerMultiWorldSideRoomsDescription = (roomsNormalized: RoomsNormalized) => {
    const roomsWithExposure = getOnlyRoomsWithExposure(roomsNormalized);
    const roomsGroupedByExposure = groupRoomsByExposure(roomsWithExposure);

    if (!roomsWithExposure) {
        return "";
    }

    const entries = Object.entries(roomsGroupedByExposure);
    const prevRoomsCountByType: Record<string, number>[] = [];

    const roomsExposureDescription = entries
        .map(([_exposureKey, rooms], index) => {
            const exposure = rooms[0].exposure; // all rooms have the same exposure
            const isLastEntry = index === entries.length - 1;
            const joinSeparator = index > 0 ? (isLastEntry ? ", a okna z " : ", z ") : "z ";
            const roomsInfo = generateRoomsInfo(rooms, prevRoomsCountByType);
            prevRoomsCountByType.push(roomsInfo.roomsCountByType);

            return `${joinSeparator}${roomsInfo.description}${index === 0 ? " wychodzą na " : " na "}${generateExposureDescription(exposure)}`;
        })
        .join("");

    return roomsExposureDescription ? `Okna ${roomsExposureDescription}.` : "";
};

const generateExposureDescription = (exposure: IPlannerPropertyRoomExposureSide[]) => {
    const joinSeparator = exposure.length > 2 ? ", " : " oraz ";
    return exposure.map((exposure) => getPlannerPropertyWorldSideName(exposure)).join(joinSeparator);
};

const generateRoomsInfo = (rooms: RoomWithRequiredExposure[], pastRoomsCountByType: Record<string, number>[]) => {
    const roomTypeCountByGroupNumerals = [
        "",
        "pierwszej ",
        "drugiej ",
        "trzeciej ",
        "czwartej ",
        "piątej ",
        "szóstej ",
        "siódmej ",
        "ósmej ",
        "dziewiątej ",
        "dziesiątej "
    ];
    const numeralsToText = ["", "", "dwóch ", "trzech ", "czterech ", "pięciu ", "sześciu ", "siedmiu ", "ośmiu ", "dziewięciu ", "dziesięciu "];
    const roomsCountByType = countRoomsByType(rooms);
    const entries = Object.entries(roomsCountByType);

    const description = entries
        .map(([roomType, count], index) => {
            const countToText = numeralsToText[count] || "";
            const roomTypeToText = getPlannerPropertyRoomNameDeclensionWhere(roomType as IPlannerRoomNames)(count);
            const isLastEntry = index === entries.length - 1;
            const joinSeparator = index > 0 ? (isLastEntry ? " oraz " : ", ") : "";
            const prevRoomsCountByType = pastRoomsCountByType.reduce(
                (acc, prevCountByRoomType) => (prevCountByRoomType[roomType] ? prevCountByRoomType[roomType] + acc : acc),
                0
            );
            const groupNumeralToText = prevRoomsCountByType === 0 || count > 1 ? countToText : `${roomTypeCountByGroupNumerals[prevRoomsCountByType + 1]}`;

            return `${joinSeparator}${groupNumeralToText}${roomTypeToText}`;
        })
        .join("");

    return {
        description,
        roomsCountByType
    };
};
